<div *ngIf = "{privacyList: privacyList$ | async,
               selectedPrivacy: selectedPrivacy$ | async
               } as data">
    <mat-radio-group (change)="onChangeJobseekerPrivacy($event)" [ngModel]="data.selectedPrivacy">
        <div *ngFor="let privacy of data.privacyList" class="item">
            <mat-radio-button [value]="privacy.value">
                <div [ngClass]="{'item__label--red': data.selectedPrivacy == privacyEnum.Hidden && privacy.value == privacyEnum.Hidden}" class="item__label">{{privacyMap[privacy.value].label | translate}}</div>
            </mat-radio-button>
            <div [ngClass]="{'item__text--red': data.selectedPrivacy == privacyEnum.Hidden && privacy.value == privacyEnum.Hidden}" class="item__text">{{privacyMap[privacy.value].text | translate}}</div>
        </div>
    </mat-radio-group>

    <div class="buttons">
        <app-button (click)="onSave(data.selectedPrivacy)" [text]="'label.Save' | translate" [type]="buttonType.coloured" [typeAttribute]="buttonAttributeType.submit" class="buttons__save"></app-button>
        <app-button (click)="onCancel()" [text]="'label.Cancel' | translate" [type]="buttonType.uncoloured" [typeAttribute]="buttonAttributeType.button"></app-button>
    </div>
</div>